import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse } from '../types';
import { SitterReview } from '../types/SitterReview';

const URL = '/v2/sitter-reviews';

class SitterReviewService {
  static get(id: number, config?: AxiosRequestConfig): Promise<DataResponse<SitterReview>> {
    return axios.get(`${URL}/${id}`, config);
  }

  static getByFilter(config?: AxiosRequestConfig): Promise<PagedResponse<SitterReview>> {
    return axios.get(`${URL}`, config);
  }

  static delete(id: number, config?: AxiosRequestConfig): Promise<unknown> {
    return axios.delete(`${URL}/${id}`, config);
  }

  static patch(
    id: number,
    data: SitterReview,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<SitterReview>> {
    return axios.patch(`${URL}/${id}`, data, config);
  }

  static create(
    data: SitterReview,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<SitterReview>> {
    return axios.post(URL, data, config);
  }
}

export { SitterReviewService };
